const t = {
  name: "SquareFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 2C3.34772 2 2 3.34772 2 5V19C2 20.6523 3.34772 22 5 22H19C20.6523 22 22 20.6523 22 19V5C22 3.34772 20.6523 2 19 2H5Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SquareFill
};
